import React, { Component } from 'react';
import { HashRouter as Router, Route } from 'react-router-dom'

import Header from "../Header/Header"
import Hidon from "../Hidon/Hidon"
import LeadPage from "../LeadPage/LeadPage"
import Footer from "../Footer/Footer"

import Popup from '../Popup/Popup';

class App extends Component {
  constructor() {
    super();
    this.state = {
      showLoader: false,
      isPoping: false,
      popupData: {},
      hidonState: {}
    }
    this.triggerPopup = this.triggerPopup.bind(this);
    this.hidonState = this.hidonState.bind(this);
  }
  triggerPopup(data) {
    this.setState({
      isPoping: !this.state.isPoping,
    });
    if (data) {
      this.setState({
        popupData: data
      })
    }
  }
  hidonState(state) {
    this.setState({
      hidonState: state
    })
  }
  render() {
    return (
      <div className="App-Nespresso">
        <Router basename="/">
          <div>
            <Header scrollFromMenu={this.scrollFromMenu} />
            <Popup
              popupData={this.state.popupData}
              triggerPopup={this.triggerPopup}
              isPoping={this.state.isPoping} />
            <Route exact path="/" component={() => <Hidon
              triggerPopup={this.triggerPopup}
              hidonState={this.hidonState}
            />} />
            <Route path="/whoami/:whoami" component={(router) => <LeadPage
              router={router}
              triggerPopup={this.triggerPopup}
              hidonState={this.state.hidonState} />} />
            <Footer />
          </div>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.js